import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, toRefs } from "vue";
import { useStore } from "vuex";
import { Inspector, Booking, SelectOption } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectorSelect',
  props: {
    pvm: {},
    changeinspectorpvmid: {}
  },
  emits: ["inspectorpvmselected"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();
const inspectorlist = computed(() => store.getters["diary/inspectorlist"]);
const propertyvisitmanagement = computed(
  () => store.getters["propertyvisitmanagement/getBookingsData"]
);
const props = __props;
const emit = __emit;
const dynamicInspectorRefs = ref<{ [key: string]: HTMLElement | undefined }>({});
const setBookingsData = (data: Booking[]) =>
  store.commit("propertyvisitmanagement/setBookings", data);
const { pvm, changeinspectorpvmid } = toRefs(props);
const changeStatusReport = () => {
  emit("inspectorpvmselected", pvm.value.id);

  const dropdown = dynamicInspectorRefs.value[`dynamicInspectorRefs-${pvm.value.id}`] as any;
  if (dropdown) {
    dropdown.activate();
  }
};
const onSelectInspector = async (id: string | undefined, val: string) => {
  const pmIndex = propertyvisitmanagement.value.findIndex(
    (r: Booking) => r.id === id
  );
  propertyvisitmanagement.value[pmIndex].inspector = val;
  setBookingsData(propertyvisitmanagement.value);
  pvm.value.id = id;
  emit("inspectorpvmselected", "");
};
const closeDropdown = () => {
  emit("inspectorpvmselected", "");
};
const inspector = ref<SelectOption>(new SelectOption());

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", { onFocusout: closeDropdown }, [
    _withDirectives(_createVNode(_component_singleselect_text, {
      modelValue: inspector.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inspector).value = $event)),
      "track-by": "slug",
      label: "name",
      options: inspectorlist.value,
      "allow-empty": true,
      taggable: false,
      class: "statusdtopdown",
      ref: 'dynamicInspectorRefs-' + _unref(pvm).id,
      onSelect: _cache[2] || (_cache[2] = ($event: any) => (onSelectInspector(_unref(pvm).id, $event)))
    }, _createSlots({ _: 2 }, [
      (_unref(pvm).id)
        ? {
            name: "clear",
            fn: _withCtx(() => [
              _createElementVNode("i", {
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onSelectInspector(_unref(pvm).id, $event)), ["prevent","stop"])),
                class: "multiselect__clear fa fa-times",
                "aria-label": "Clear"
              }, null, 32)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "options"]), [
      [_vShow, _unref(changeinspectorpvmid) === _unref(pvm).id]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass({ 'transparent-text': !_unref(pvm).inspector.id }),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (changeStatusReport()))
    }, _toDisplayString(_unref(pvm).inspector.id ? _unref(pvm).inspector.name : "Select Dropdown"), 3), [
      [_vShow, _unref(changeinspectorpvmid) != _unref(pvm).id]
    ])
  ], 32))
}
}

})